import React, { useState, useEffect } from "react";
import "./Navbar.css";
import logo from "../../Assets/Logo.jpeg";
import { Link } from "react-router-dom";

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 80);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const closeMenu = () => setIsMenuOpen(false);

  return (
    <nav className={isScrolled ? "navbar active" : "navbar"}>
      {/* LOGO */}
      <div className="logo-container">
        <Link to="/" className="logo-link" onClick={closeMenu}>
          <div className="logo-wrapper">
            <img src={logo} alt="Shree Ram Car Rental .com Logo" className="logo-img" />
            <span className="logo-text">ShreeRamCarRental.com</span>
          </div>
        </Link>
      </div>

      {/* NAV LINKS */}
      <ul className={isMenuOpen ? "nav-links active" : "nav-links"}>
        <li><Link to="/" onClick={closeMenu}>Home</Link></li>
        <li><Link to="/about" onClick={closeMenu}>About</Link></li>
        <li><Link to="/terms&conditions" onClick={closeMenu}>Terms & Conditions</Link></li>
        <li><Link to="/tours" onClick={closeMenu}>Tours</Link></li>
        <li><Link to="/selfdrive" onClick={closeMenu}>Self Drive</Link></li>
        <li><Link to="/contact" onClick={closeMenu}>Contact</Link></li>
      </ul>

      {/* MENU ICON */}
      <button 
        className="menu-icon" 
        onClick={() => setIsMenuOpen(!isMenuOpen)}
        aria-label="Toggle navigation"
      >
        {isMenuOpen ? "✕" : "☰"}
      </button>
    </nav>
  );
};

export default Navbar;